export default __webpack_public_path__ + "static/about-us-support-1-e40f94f01c60c8cce9655e4ee65a1884.png";